import { Component, OnInit, ViewChild } from '@angular/core';
import { BookingStepService } from '../../services/booking-step.service';
import { BookingOrderService } from '../../services/booking-order.service';

@Component({
  selector: 'app-booking-events-products',
  templateUrl: './booking-events-products.component.html',
  styleUrls: ['./booking-events-products.component.css']
})
export class BookingEventsProductsComponent implements OnInit {

  constructor(
    protected bookingStepService: BookingStepService,
    private bookingOrderService: BookingOrderService,
  ) {
  }

  @ViewChild('eventConfigurator', {static: true}) eventConfigurator;

  ngOnInit(): void {
    const eventBookingCache = this.bookingOrderService.eventCache;

    this.eventConfigurator.child = eventBookingCache.guestOfHonor;

  }

  onBackwardClick(): void {
    this.bookingStepService.back();
  }

  onForwardClick(): void {
    if (this.forwardError) {
      return;
    }

    this.bookingStepService.forward();
  }

  get forwardError(): string {
    return this.bookingOrderService.eventCache.invalidReason;
  }
}
